// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"d245932cf6896612f511","655":"62af15d3d744b8a490b3"}[chunkId] + ".js";
};